import { BASE_END_POINT } from "../../parametros";
import i18n from "i18next";

async function buscarTotalDePersonagens(): Promise<number> {

    const url = `${BASE_END_POINT}/api-v1/personagens/totalpersonagens`;

    const response = await fetch(url, {
        headers: { 'Accept-Language': i18n.language }
    });

    if (!response.ok) {
        throw new Error(`Erro ao buscar total de personagens. Código: ${response.status}`);
    }

    return await response.json() as number;
}

export {
    buscarTotalDePersonagens
};
